import { Intent, Spinner, SpinnerSize } from '../ui';
import React, { FunctionComponent } from 'react';

const LoadingSpinner: FunctionComponent = () => {
  return (
    <div className="flex justify-center items-center w-full h-screen">
      <Spinner intent={Intent.PRIMARY} size={SpinnerSize.STANDARD} />
    </div>
  );
};

export default LoadingSpinner;
